const automations = {
  pageName: 'Automações',
  btnCreate: 'Criar',
  btnUseTemplate: 'Usar modelo',
  mainTabs: {
    titleAutomationsCenter: 'Centro de Automações',
    titleAutomationsExisting: 'Automações Existentes',
  },
  deleteModal: {
    header: 'Excluir automações',
    body: 'Você está prestes a excluir as automações {{num}}.',
    success: 'As automações foram excluídas com sucesso',
  },
  table: {
    header: {
      name: 'Nome',
      nextRun: 'Próxima execução',
      lastRun: 'Última execução',
      createdAt: 'Data de criação',
      createdBy: 'Criado por',
      actionType: 'Tipo de Ação',
      status: 'Status',
      profiles: 'Perfis',
      suppliers: 'Fornecedores',
      attributes: 'Atributos',
      areas: 'Zonas',
      locations: 'Localizações',
      airports: 'Aeroportos',
      run: 'Executar',
    },
    filters: {
      status: {
        title: 'Status',
        options: {
          on: 'Em',
          off: 'Desativado',
        },
      },
      profiles: {
        title: 'Perfis',
      },
      suppliers: {
        title: 'Fornecedores',
      },
      attributes: {
        title: 'Atributos',
      },
      areas: {
        title: 'Zonas',
      },
      locations: {
        title: 'Localizações',
      },
      airports: {
        title: 'Aeroportos',
      },
      actionType: {
        title: 'Tipo de Ação',
        options: {
          routingProcess: 'Processo de Encaminhamento',
          busRoute: 'Linha de ônibus',
          driverAssignment: 'Atribuição de Motorista',
        },
      },
    },
    actions: {
      run: 'Executar agora',
      duplicate: {
        title: 'Duplicar',
      },
      delete: {
        title: 'Remover',
      },
    },
    toasts: {
      delete: {
        success: 'Excluído com sucesso!',
        error: 'Ocorreu um erro! Não foi possível excluir a zona',
      },
      run: {
        success: 'Automação enfileirada. Será executada em breve',
        error: 'Ocorreu um erro! Não foi possível executar a automação',
      },
    },
  },
  wizard: {
    titleCreate: 'Criar',
    titleUpdate: 'Atualizar',
    trigger: {
      title: '1.Acionador',
      subTitle: 'Um acionador é um evento que inicia sua automação',
      loadingText: 'Por favor, aguarde carregando os parâmetros.',
      selectTrigger: {
        label: 'Acionar',
      },
      btnContinue: 'Prosseguir',
    },
    action: {
      title: '2.Ação',
      subTitle: 'Uma ação é um evento realiza após ser iniciado',
      loadingText: 'Por favor, aguarde carregando os parâmetros.',
      selectAction: {
        label: 'Ação',
      },
      btnContinue: 'Prosseguir',
    },
    information: {
      title: '3.Informações',
      subTitle: 'Informações comuns sobre a automação',
      name: 'Nome da automação',
      description: 'Descrição',
      profile: 'Perfil',
      supplier: 'Fornecedor',
      attributes: 'Atributos',
      areas: 'Zona',
      locations: 'Localizações',
      airports: 'Localizações de Aeroportos',
      btnSubmit: 'Enviar',
    },
  },
  automationsCenter: {
    tabs: {
      all: 'Tudo',
      routingProcess: 'Processo de Encaminhamento',
      busRoute: 'Linha de ônibus',
      driverAssignment: 'Atribuição de Motorista',
    },
  },
  toasts: {
    error: 'Ocorreu um erro',
    successCreated: 'Criado com sucesso',
    successUpdated: 'Atualizado com sucesso',
  },
};

export default automations;
